export { default } from '@relo/sports-components/es/AccordionChildItems';
export * from '@relo/sports-components/es/AccordionChildItems';
